/// <amd-module name="Wit/WorkItemModel/WorkItem/LegacyTfsClient" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IWorkItemTrackingRestClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking";
import { getWorkItemTrackingClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking";
import { ILegacyTfsClient } from "Wit/WorkItemModel/OM/ILegacyWorkItem";

export class LegacyTfsClient implements ILegacyTfsClient {
    private _pageContext: IVssPageContext;
    private _restClient: IWorkItemTrackingRestClient;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._restClient = getWorkItemTrackingClient(pageContext);
    }

    public async beginAttachmentUpload(
        projectNameOrId: string,
        file: File,
        areaPath: string,
        chunkSize?: number,
        shouldContinue?: any,
        fileName?: string
    ): Promise<any> {
        return this._restClient.createAttachment(file, projectNameOrId, fileName, undefined, areaPath);
    }
}
